import React from 'react';
import TimedQuestionWidget from './TimedQuestionWidget';

const PureTimed = props => {
  return props.url ? (
    <TimedQuestionWidget {...props} />
  ) : <div>No image to display.</div>;
}

export default PureTimed